import { calculateGradients } from "./gradients";
import type { PipeFrictionContext } from "../d";
import type { PipeFrictionIntermediates } from "..";

export type FValues = {
  F1: number;
  F2: number;
  F3: number;
  F3tick: number;
  F4: number;
  F5: number;
  F6: number;
  F6tick: number;
  F7: number;
};

export enum DunsRosFlowRegimes {
  BUBBLE = "Bubble",
  SLUG = "Slug",
  MIST = "Mist",
  TRANSITION = "Transition",
  LIQUID = "Liquid"
}

export type Gradients = {
  staticGradient: number;
  frictionGradient: number;
  [key: string]: unknown;
};

export function getDunsRosFrictionProperties(
  context: PipeFrictionContext
): PipeFrictionIntermediates {
  const {
    fluidPropertiesContext: {
      fluidFrictionProperties: {
        flowRegime,
        liquidViscosityNumber,
        liquidVelocityNumber,
        gasVelocityNumber,
        pipeDiameterNumber,
        inSituLiquidFlowRateCFS,
        inSituGasFlowRateCFS
      }
    },
    pipeLengthFt,
    epsilonD,
    VSG
  } = context;

  const { frictionGradient, staticGradient, ...intermediates } =
    calculateGradients(context);

  // D172: =D142/(D142+D145)
  const inSituLiquidHoldUp =
    inSituLiquidFlowRateCFS / (inSituLiquidFlowRateCFS + inSituGasFlowRateCFS);

  // D318: =D314*D3
  const frictionPressurePSIA = frictionGradient * pipeLengthFt;

  // dPg/dz
  // D320: =D316*D3*SIN(D8)
  // const hydrostaticPressurePSIA = staticGradient * hydrostaticSum;

  const PipeFrictionIntermediates: PipeFrictionIntermediates = {
    frictionPressurePSIA,
    flowRegime,
    liquidViscosityNumber,
    liquidVelocityNumber,
    gasVelocityNumber,
    pipeDiameterNumber,
    inSituLiquidHoldUp,
    epsilonD,
    VSG,
    staticGradient,
    frictionGradient,
    ...intermediates
  };

  return PipeFrictionIntermediates;
}
